function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354.807,
    height: 347.277,
    viewBox: "0 0 93.876 91.884",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M92.355 61.363v29.1H62.35l11.486-11.14-14.533-13.868 7.267-7.048 14.299 14.096zm-60.01 29.1H2.342v-29.1l11.486 11.14 14.3-14.096 7.266 7.048-14.534 13.868zm-30.004-58.2v-29.1h30.005L20.859 14.301 35.393 28.17l-7.267 7.048-14.299-14.096zm60.01-29.1h30.004v29.1l-11.486-11.14-14.3 14.095-7.266-7.048 14.533-13.868z",
    style: {
      InkscapeFontSpecification: "artilleriet-icons",
      whiteSpace: "pre"
    },
    "aria-label": "\\uE907",
    fontSize: 120,
    fontFamily: "artilleriet-icons"
  }));
}

export default SvgMaximize;